import $ from 'jquery';
import imagesLoaded from 'imagesloaded';

import SiteHeader from "./components/site-header";
import HomeSlider from "./components/home-slider";
import HandheldMenu from "./components/handheld-menu";
import CookiesConsent from "./components/cookies-consent";
import DropdownMenu from "./components/dropdown-menu";
import Accordion from "./components/accordion";
import Gallery from "./components/gallery";
import NewsSlider from "./components/news-slider";
import HomepageProductsSlider from "./components/home-products-slider";
import ProductThumbsSlider from "./components/product-thumbnails";
import RelatedProductsSlider from "./components/products-slider-2";
import TreatmentsSlider from "./components/treatments-slider";
import FilterProducts from "./components/products-filters";
import Tabs from "./components/tabs";
import SearchToggler from "./components/search-toggler";
import ScrollInView from "./components/scroll-in-view";

import DeviceManager from "./utils/device-manager";
import "../js/components/products-images"
import '../js/components/ajax-product';
import '../js/components/product-calculator';
import '../js/components/anchor';
import '../js/components/products-filters';
// import '../js/components/back-to-top';

// (function ($) {
	// window.$ = $;

$(function () {

	const bootstrapApp = () => {
		const $html = $("html");

		// Touch device detection
		if (DeviceManager.isHandheld()) {
			$html.addClass("touch");

			if (DeviceManager.isIos()) {
				$html.addClass("ios");
			}
		} else {
			$html.addClass("no-touch");
		}

		// IE detection
		if (DeviceManager.isIe11()) {
			$html.addClass("ie11");
		} else if (DeviceManager.isEdge()) {
			$html.addClass("edge");
		}
	}
	
	const instanciateComponents = () => {
		// General components
		const siteHeader = new SiteHeader($(".site-header"), 20);

		// Home slider component
		const $homesSliders = $(".homepage-slider .swiper-container");
		if ($homesSliders.length) {
			$homesSliders.each(function (index, el) {
				const homeSlider = new HomeSlider($(el));
			});
		}

		// Homepage products slider component
		const $homeProductsSliders = $(".home-products .swiper-container");
		if ($homeProductsSliders.length) {
			$homeProductsSliders.each(function (index, el) {
				const homeProductsSlider = new HomepageProductsSlider($(el));
			});
		}

		// News slider component
		const $homeNewsSliders = $(".home-tutos .swiper-container");
		if ($homeNewsSliders.length) {
			$homeNewsSliders.each(function (index, el) {
				const homeNewsSlider = new NewsSlider($(el));
			});
		}

		// Product thumbnails component
		const $productThumbsSliders = $(".single-product .product-images__thumbnails");
		if ($productThumbsSliders) {
			$productThumbsSliders.each(function (index, el) {
				const productThumbsSlider = new ProductThumbsSlider($(el));
			});
		}

		// Related products component
		const $relatedProductsSliders = $(".related-products .swiper-container");
		if ($relatedProductsSliders.length) {
			$relatedProductsSliders.each(function (index, el) {
				const relatedProductsSlider = new RelatedProductsSlider($(el));
			});
		}

		// Treatments component
		const $treatmentsSliders = $(".home-treatments .swiper-container");
		if ($treatmentsSliders.length) {
			$treatmentsSliders.each(function (index, el) {
				const treatmentsSlider = new TreatmentsSlider($(el));
			});
		}

		// Cookie consent
		if (typeof tarteaucitron !== "undefined" && tarteaucitron) {
			// Tarteaucitron cookie settings
			let tarteaucitronLang = '';
			switch(document.documentElement.lang) {
				case 'fr-FR':
				tarteaucitronLang = 'fr';
				break;
				case 'de-DE':
				tarteaucitronLang = 'de';
				break;
				default:
					tarteaucitronLang = 'fr';
			}

			const cookiesConsent = new CookiesConsent(tarteaucitronLang, false);
		}

		// Scroll in view component
		const $scrollInViewElements = $(".scroll-in-view");
		if ($scrollInViewElements.length) {
			$scrollInViewElements.imagesLoaded(function () {
				const scrollInView = new ScrollInView($scrollInViewElements);
			});
		}
	}

	bootstrapApp();
	instanciateComponents();

});

// })(jQuery);
